import React from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import conf from '../../conf';
import { FlexContainerRowLRPadding, NavButtons, PageWrapper } from '../styled/skylab/page';
import { SignUpForm } from '../styled/components/sign-up';
import Banner from '../banner';
import CheckoutPurchaseInfo from './checkout-purchase-info';
import { SetupFormFields } from '../shared/forms/setup';
import { catchNextClick } from '../helpers/sign-up';
const Setup = ({ partnerSignup, containsInvalidOrMissingFields, isDirectToBuy, continueLink, continueLinkText, showThirdBullet, }) => {
    const { search } = useLocation();
    return (React.createElement("div", null,
        React.createElement(Banner, { backgroundImage: `${conf.ASSET_PATH}/assets/images/banner-background.png`, image: `${conf.ASSET_PATH}/assets/images/company_w.svg`, partnerSignup: partnerSignup, primaryText: `Activate your ${isDirectToBuy ? 'account' : 'free trial'} today`, secondaryText: isDirectToBuy ? '' : 'Start your free trial today' }),
        React.createElement(PageWrapper, null,
            React.createElement(FlexContainerRowLRPadding, null,
                React.createElement("div", null,
                    React.createElement("h3", { "data-ref": 'buy.signup.setup-header', className: 'text-md' }, 'Tell us about your company, and we\'ll jump-start your setup'),
                    React.createElement(SignUpForm, null,
                        React.createElement(SetupFormFields, null),
                        React.createElement(NavButtons, null,
                            React.createElement(Link, { "data-ref": 'buy.signup.setup.next-button', to: `${continueLink}${search}`, onClick: e => catchNextClick(e, containsInvalidOrMissingFields), tabIndex: 0 },
                                React.createElement("button", { className: 'formComplete primary large', disabled: containsInvalidOrMissingFields, "data-ref": 'buy.signup.continue-signup-button' }, continueLinkText))))),
                React.createElement(CheckoutPurchaseInfo, { start: false, isDirectToBuy: isDirectToBuy, partnerSignup: partnerSignup, showThirdBullet: showThirdBullet })))));
};
export default Setup;
